module.exports = __webpack_public_path__ + "img/login_title.db23d720.png";